import { CustomFieldCaseCategories } from "../../enums/settings/customField/CustomFieldCaseCategories";

export const CustomFieldCaseCategoriesLabel = new Map<number, string>([
    [CustomFieldCaseCategories.Case, 'Case'],
    [CustomFieldCaseCategories.Contact, 'Contact'],
    [CustomFieldCaseCategories.Reviews, 'Reviews'],
    [CustomFieldCaseCategories.Staff, 'Staff'],
    [CustomFieldCaseCategories.Subject, 'Subject']
]);
